/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookmarkIcon24Regular = forwardRef('BookmarkIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 6.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2.25A3.75 3.75 0 0 0 4.25 6v13.323c0 1.758 1.925 2.837 3.425 1.92l3.933-2.408a.75.75 0 0 1 .784 0l3.933 2.407c1.5.918 3.425-.16 3.425-1.919V6A3.75 3.75 0 0 0 16 2.25H8ZM5.75 6A2.25 2.25 0 0 1 8 3.75h8A2.25 2.25 0 0 1 18.25 6v13.323a.75.75 0 0 1-1.142.64l-3.933-2.408a2.25 2.25 0 0 0-2.35 0l-3.933 2.408a.75.75 0 0 1-1.142-.64V6Z" })));
});
